import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 w-full mb-5" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = ["innerHTML"]

import {computed, onMounted, ref, toRef} from "vue";
import {useSystemStore} from "@/stores/system/SystemStore";
import {useI18n} from "vue-i18n";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditGlobalSettingsPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();

const props = __props
const popupData = toRef(props, 'data');

const systemStore = useSystemStore();

const rules = computed(() => {
  return {
    value: { required: helpers.withMessage(t('validators.required'), required) },
  }
})

const v$ = ref(useVuelidate(rules, popupData));

onMounted(()=>{
  systemStore.modal.validator = v$;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('settingManagment.grid.displayName')), 1),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.displayName) = $event)),
              disabled: "",
              class: "w-full",
              id: "displayName"
            }, null, 512), [
              [_vModelText, popupData.value.displayName]
            ]),
            _hoisted_5
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('settingManagment.grid.value')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.value) = $event)),
                class: "w-full",
                rows: "5",
                id: "value"
              }, null, 512), [
                [_vModelText, popupData.value.value]
              ])
            ])
          ]),
          _createElementVNode("div", {
            innerHTML: popupData.value.description,
            class: "helpText mt-4"
          }, null, 8, _hoisted_9)
        ])
      ])
    ])
  ]))
}
}

})